import { QueryHookOptions, useQuery } from '@apollo/client'
import B2C_GET_LOT_BY_ID from '@graphql/queries/getLotById.query'
import { B2CGetLotByIdQuery, B2CGetLotByIdQueryVariables } from 'parkdepot-shared/gql/graphql'

const useCarpayGetLotById = (opts: QueryHookOptions<B2CGetLotByIdQuery, B2CGetLotByIdQueryVariables>) => {
    return useQuery(B2C_GET_LOT_BY_ID, { ...opts })
}

export default useCarpayGetLotById
